import { CheckoutDirectDebitMethod } from './checkout-direct-debit-method.enum';

export interface CheckoutDirectDebitConfig {
  method: CheckoutDirectDebitMethod;
}
